module.exports = __webpack_public_path__ + "static/img/backpack9.26cf68b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/backpack9.jpg
// module id = 176
// module chunks = 2